import React from 'react';
import { useNavigate } from 'react-router-dom';

const SplashScreen = ({ onNavigateToPariaAI, onNavigateToClasses }) => {
  const navigate = useNavigate();
  return (
    <>
      {/* Add styles for animations */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }
        
        .splash-banner {
          animation: fadeInUp 0.6s ease-out;
        }
        
        .splash-content {
          animation: fadeInUp 0.8s ease-out;
        }
        
        .splash-button {
          transition: all 0.3s ease;
        }
        
        .splash-button:hover {
          transform: translateY(-2px);
        }
        
        .splash-button:hover .button-emoji {
          transform: scale(1.2) rotate(10deg);
        }
        
        .footer-heart:hover {
          transform: scale(1.4);
        }
      `}</style>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Nunito', sans-serif",
        backgroundColor: '#F4ABBA',
        color: '#333',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Banner - matches Header design patterns */}
        <div className="splash-banner" style={{
          position: 'absolute',
          top: '25px',
          left: '25px',
          right: '25px',
          backgroundColor: 'white',
          color: '#333',
          padding: '12px 20px',
          borderRadius: '25px',
          fontSize: '21px',
          fontWeight: 'bold',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          zIndex: 10,
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          transition: 'all 0.3s ease'
        }}>
          <img 
            src="https://static.wixstatic.com/media/174d84_79ee5070ea8344f79b737bd556619e15~mv2.png"
            alt="Paria"
            style={{
              height: '56px',
              width: '56px',
              borderRadius: '50%',
              objectFit: 'cover',
              marginRight: '12px'
            }}
          />
          <span style={{ fontSize: '24px' }}>🎓</span>
          <span>For private 1-on-1 classes with Paria, check out</span>
          <a 
            href="https://patreon.com/paria" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#DD2E44', 
              textDecoration: 'underline',
              fontWeight: '700',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.color = '#EA596E';
              e.target.style.textShadow = 'none';
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '#DD2E44';
              e.target.style.textShadow = 'none';
            }}
          >
            patreon.com/paria
          </a>
          <span>Limited slots available!</span>
        </div>

        {/* CTA Buttons - Top Right Corner */}
        <div style={{
          position: 'absolute',
          top: '110px',
          right: '25px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          zIndex: 10
          }}>
            {/* Paria AI Button - matches TalkToParia button style */}
            <button
              onClick={() => {
                if (onNavigateToPariaAI) {
                  onNavigateToPariaAI();
                } else {
                  navigate('/learning-hub');
                }
              }}
              className="splash-button"
              style={{
                backgroundColor: 'white',
                color: '#DD2E44',
              padding: '12px 24px',
                borderRadius: '25px',
                border: '2px solid transparent',
                fontFamily: "'Nunito', sans-serif",
              fontSize: '16px',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              gap: '8px',
                position: 'relative',
                overflow: 'visible',
              whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'linear-gradient(to right, #fff5f7, white, #fff5f7)';
                e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.25)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'white';
                e.target.style.boxShadow = '0 4px 15px rgba(221, 46, 68, 0.15)';
              }}
            >
            <span className="button-emoji" style={{ fontSize: '18px', transition: 'transform 0.3s ease' }}>🤖</span>
              Paria AI
            <span className="button-emoji" style={{ fontSize: '18px', transition: 'transform 0.3s ease' }}>💝</span>
            </button>

            {/* 1-on-1 Classes Button - matches primary button style */}
            <button
              onClick={onNavigateToClasses}
              className="splash-button"
              style={{
                backgroundColor: '#DD2E44',
                color: 'white',
              padding: '12px 24px',
                borderRadius: '25px',
                border: '2px solid transparent',
                fontFamily: "'Nunito', sans-serif",
              fontSize: '16px',
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(221, 46, 68, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              gap: '8px',
                position: 'relative',
                overflow: 'visible',
              whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#EA596E';
                e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#DD2E44';
                e.target.style.boxShadow = '0 4px 15px rgba(221, 46, 68, 0.3)';
              }}
            >
            <span className="button-emoji" style={{ fontSize: '18px', transition: 'transform 0.3s ease' }}>👸🏼</span>
              1-on-1 Classes
            <span className="button-emoji" style={{ fontSize: '18px', transition: 'transform 0.3s ease' }}>✨</span>
            </button>
          </div>

        {/* Main Content */}
        <div className="splash-content" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '40px',
          textAlign: 'center',
          padding: '40px 20px',
          maxWidth: '600px',
          width: '100%'
        }}>
        </div>

        {/* Footer - matches existing footer design */}
        <div style={{
          position: 'absolute',
          bottom: '15px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          padding: '8px 16px',
          borderRadius: '20px',
          boxShadow: '0 4px 12px rgba(221, 46, 68, 0.1)',
          fontFamily: "'Nunito', sans-serif",
          color: '#888',
          fontSize: '13px',
          transition: 'all 0.3s ease'
        }}>
          <span>With</span>
          <span className="footer-heart" style={{ 
            color: '#DD2E44',
            cursor: 'pointer',
            display: 'inline-block',
            transition: 'transform 0.3s ease'
          }}>♥</span>
          <span>by</span>
          <a
            href="https://pariaakhavass.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#DD2E44',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'color 0.2s ease'
            }}
          >
            Paria
          </a>
        </div>
      </div>
    </>
  );
};

export default SplashScreen;
